import React, { ReactElement } from 'react';
import { LoaderSpinner, LoaderSpinnerProps } from '../../CiscoUi';

export function CenteredSpinner({
  size = 'default',
}: LoaderSpinnerProps): ReactElement {
  return (
    <div className="flex flex-center dbl-margin-top">
      <LoaderSpinner size={size} />
    </div>
  );
}
